<template>
  <div>
    <div :class="prior === 'row' ? 'image-row-list-wrapper' : 'image-col-list-wrapper'">
      <b-loading :is-full-page="false" :active="loading" />
      
      
      <div class="image-item" 
          v-for="image in imageDatas._data" 
          :key="image.id"
          :class="{ 'selected': checkedRows.includes(image) }"
          @click="handleClick(image)"
      >
        <div class="image-name">
          <image-name :image="image" />
        </div>

        <div class="image-label">
          <image-thumbnail :image="image" :macro="true" :size="500" :key="`${image.id}-macro-256`" :extra-parameters="{Authorization: 'Bearer ' + localShortTermToken}" :blindMode="blindMode" />
        </div>

        <div class="scan-mode-wrapper">
          <div
            v-for="(value, idx) in stainingInfo[image.id]"
            :key="idx"
            class="scan-mode"
            :style="{ backgroundColor: value.colorCode, width: 100 / stainingInfo[image.id].length + '%' }"
            :title="value.name"
          ></div>
        </div>

        <div class="display-row">
          <div v-if="image.focalPlanes > 1" class="zstack-info">
            Z ({{ image.focalPlanes }}/{{ image.zSpacing }}μm)
          </div>

          <div v-if="externImageIds.has(image.id)" class="ai-info">
            <img src="@/assets/images/sparkle.svg" id="ai" alt="ai" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import {get} from '@/utils/store-helpers';
import {ImageInstanceCollection} from 'cytomine-client';
import ImageThumbnail from '@/components/image/ImageThumbnail';
import ImageName from '@/components/image/ImageName';

export default {
  name: 'image-list-component',
  components : {
    ImageThumbnail,
    ImageName
  },
  props: {
    prior: { type: String, default: 'row' },
    caseId: {
      type: String,
      required: true,
    },
    revision: {
      type: Number,
      default: 0
    },
    checkedRows: {
      type: Array,
      default: () => []
    },
    selectMode: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      loading: true,

      imageCollection: {},
      imageDatas: {},
      externResult: {},
      stainingInfo: {},

      localShortTermToken: '',
    };
  },
  watch: {
    revision() {
      this.fetchImageCollection();
    },
    shortTermToken(newVal) {
      if (!this.localShortTermToken && newVal) {
        this.localShortTermToken = newVal;
      }
    },
  },
  computed:  {
    // currentUser: get('currentUser/user'),
    // configUI: get('currentProject/configUI'),
    project: get('currentProject/project'),
    shortTermToken: get('currentUser/shortTermToken'),
    blindMode() {
      return ((this.$store.state.currentProject.project || {}).blindMode) || false;
    },
    wrapperClass() {
      return this.prior == 'col'
        ? 'image-col-list-wrapper'
        : 'image-row-list-wrapper';
    },
    externImageIds() {
      if (!this.externResult || !Array.isArray(this.externResult.collection)) return new Set();
      return new Set(this.externResult.collection.map(r => r.imageInstanceId));
    },
  },
  methods: {
    
    handleClick(image) {
      if (this.selectMode) {
        this.toggleCheckedRow(image);
      }
      else {
        this.$router.push(`/case/${image.project}/image/${image.id}`);
      }
    },
    toggleCheckedRow(image) {
      const isChecked = this.checkedRows.includes(image);
      const updated = isChecked
        ? this.checkedRows.filter(i => i !== image) // 제거
        : [...this.checkedRows, image];             // 추가

      this.$emit('update:checkedRows', updated);
    },
    async fetchImageCollection() {
      this.imageDatas = await this.imageCollection.fetchPage(0);
      console.log('fetchImageCollection:::', this.imageDatas);
    },
    async fetchExternResult() {
      this.externResult = await this.project.fetchExternResult();
      console.log('fetchExternResult:: ', this.externResult);
    },
    async fetchStainingInfo() {
      this.stainingInfo = await this.project.fetchStainingInfo();
      console.log('fetchStainingInfo:: ', this.stainingInfo);
    },
  },
  async created() {
    this.imageCollection = new ImageInstanceCollection({
      filterKey: 'case',
      filterValue: this.caseId,
    });
    this.localShortTermToken = this.shortTermToken;

    try {
      await Promise.all([
        this.fetchImageCollection(),
        // this.fetchExternResult(),
        this.fetchStainingInfo(),
        
      ]);
      console.log('blindMode?', this.blindMode);
    }
    catch (error) {
      console.error('이미지 또는 외부 결과 로드 실패:', error);
    }
    finally {
      this.loading = false; // 성공 여부와 관계없이 실행
    }
  },
};

</script>

<style scoped>
.filename {
  width: 100px;        /* 가로 고정 */
  word-wrap: break-word; /* 단어 단위로 줄바꿈 */
  white-space: normal;   /* 기본 줄바꿈 허용 */
}


/* row: 가로 먼저 채우기 (left → right) */
.image-row-list-wrapper {
  display: flex;           /* 플렉스 컨테이너로 설정 */
  flex-wrap: wrap;         /* 요소가 가로로 꽉 차면 다음 줄로 넘기기 */
  justify-content: flex-start;
  align-content: flex-start;

  height: calc(100vh - 120px);
  overflow: auto;
}

.image-row-list-wrapper > * {
  flex: 0 0 auto;          /* 요소 크기를 유지하고 가로 방향으로 배치 */
}


/* col: 세로 먼저 채우기 (top → bottom) */
.image-col-list-wrapper {
  display: inline-grid; 
  grid-auto-flow: column;          /* 세로 먼저 채움 */
  gap: 10px;
  height: 100%;                   /* 부모 높이 */
  grid-template-rows: repeat(3, 25rem); /* 한 열에 들어갈 최대 행 수 */
}

.image-item {
  width: 7rem;
  margin: 5px;
  font-size: 0.8rem;

  cursor: pointer;
  padding: 0 12px;
  box-sizing: content-box;
  border-radius: 4px;
  transition: background-color 0.2s;

  /* 세로 방향으로 요소들을 배치 */
  display: flex;
  flex-direction: column;
}

.image-item.selected {
  background-color: #d0e7ff;
}

.image-name {
  height: 2.4rem;
}

.image-label {
  height: 21rem;
  cursor: pointer;

  /* 핵심: 내용이 넘치면 세로 스크롤 생성 */
  overflow-y: auto; 
  overflow-x: hidden; /* 가로 스크롤은 방지 */

  /* 내부 이미지 정렬 (선택 사항) */
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f9f9f9; /* 영역 구분을 위한 아주 연한 배경색 */

  /* background-color: white; */
  /* box-shadow: 0 0 3px rgba(0, 0, 0, 0.2); */
}

/* 썸네일 이미지 스타일 강제 조정 */
.image-label ::v-deep img {
  width: 100%;
  height: auto; /* 세로로 길어지는 것을 허용하여 스크롤 유발 */
  display: block;
}

.image-label::-webkit-scrollbar {
  width: 4px;
}
.image-label::-webkit-scrollbar-thumb {
  background-color: #cccccc;
  border-radius: 4px;
}
.image-label::-webkit-scrollbar-track {
  background-color: transparent;
}

.scan-mode-wrapper {
  display: flex; /* 가로 정렬 */
  /* width: 100%; */
  height: 8px; /* 사각형 높이 */
}

.scan-mode {
  height: 100%;
}

.display-row {
  margin: 2px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.ai-info {
  width: 0.7rem;
  height: auto;

  margin-left: auto;
}
</style>
